// Utility functions for CartSection component
export const calculateQuantity = (products) => 
    products?.reduce(
        (sum, currentItem) => sum + parseInt(currentItem.quantity),
        0
    ) || 0;

export const calculateTotalCartQuantity = (implantProducts, instrumentProducts) => 
    calculateQuantity(implantProducts) + calculateQuantity(instrumentProducts);

export const isMobileView = () => window.innerWidth <= 576;

export const getCartTitle = (t, cartProductLength) => 
    `${t('ConsignmentAdd.submit.inYourCart')} (${cartProductLength})`;

export const getItemListViewTitle = (t, implantProducts, instrumentProducts) => 
    `${t('orders.orderSummaryTabs.ItemListView')} (${calculateTotalCartQuantity(implantProducts, instrumentProducts)})`;
